


import { Text } from 'slate';
import $ from '../utils/dom';

function parseHtml(elem, children, editor) {
  const $elem = $(elem);
  children = children.filter((child) => {
    if (Text.isText(child)) return true;
    if (editor.isInline(child)) return true;
    return false;
  });

  // 无 children ，则用纯文本
  if (children.length === 0) {
    children = [{ text: $elem.text().replace(/\s+/gm, ' ') }];
  }
  console.log('parse-elem-html', children, elem);
  return {
    type: 'topic',
    // @ts-ignore
    children,
  };
}

export const parseHtmlConf = {
  selector: 'span:not([data-w-e-type])', // data-w-e-type 属性，留给自定义元素，保证扩展性
  parseElemHtml: parseHtml,
};
